// Shared constants for the CIEDA web application

export const CIEDA_PHONE = "+221 76 604 22 74";
export const CIEDA_PHONE_TEL = "tel:+221766042274";

export const REGIONS = [
  { id: "dakar", label: "Dakar" },
  { id: "thies-mbour", label: "Thiès-Mbour" },
  { id: "kaolack", label: "Kaolack" },
  { id: "saint-louis", label: "Saint-Louis" },
  { id: "fatick", label: "Fatick" },
  { id: "diourbel-touba", label: "Diourbel-Touba" },
] as const;

export type RegionId = (typeof REGIONS)[number]["id"];

export const NAV_LINKS = [
  { label: "Produits", href: "#brands" },
  { label: "À Propos", href: "#about" },
  { label: "Distribution", href: "#logistics" },
  { label: "Catalogue", href: "#catalog" },
  { label: "Contact", href: "#contact" },
] as const;
